/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Online_ExcludeInputs */



/**
* | output |
* | --- |
* | "Exclude" |
*
* @param {Tournaments_Online_ExcludeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_online_exclude = /** @type {((inputs?: Tournaments_Online_ExcludeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Online_ExcludeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exclure")
	if (locale === "es") return /** @type {LocalizedString} */ ("Excluir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Escludi")
	return /** @type {LocalizedString} */ ("Exclude")
});